import { FormlyFieldConfig } from '@ngx-formly/core';

export class NewApplicationFormSchema {
  name: string;
  schema: FormlyFieldConfig[];
}
